var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6527 2.03783C11.4176 1.57995 11.0783 1.1836 10.6622 0.880637C10.2461 0.577671 9.76475 0.376532 9.25679 0.293379C8.74884 0.210227 8.22846 0.247381 7.73747 0.401855C7.24647 0.556329 6.79856 0.823816 6.42971 1.18283L6.00271 1.57333L5.58921 1.19683C5.22122 0.83086 4.7712 0.558011 4.27655 0.400954C3.7819 0.243897 3.25691 0.20717 2.74521 0.293825C2.23648 0.373144 1.75401 0.572711 1.3379 0.875947C0.921787 1.17918 0.584038 1.57734 0.352713 2.03733C0.0435001 2.64328 -0.0645528 3.33202 0.0442383 4.00356C0.153029 4.67509 0.473002 5.29448 0.957713 5.77182L5.64421 10.5998C5.69081 10.6478 5.74654 10.6859 5.80812 10.7119C5.8697 10.7379 5.93587 10.7513 6.00271 10.7513C6.06956 10.7513 6.13573 10.7379 6.1973 10.7119C6.25888 10.6859 6.31462 10.6478 6.36121 10.5998L11.0412 5.78083C11.5279 5.30303 11.8496 4.68251 11.9596 4.00941C12.0695 3.3363 11.962 2.64567 11.6527 2.03783Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8825309ed613b9d0a8da4687fa2f86b7.svg";
export { ForwardRef as ReactComponent };